/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  AIMessageInput,
  AIModel,
  AIStreamResponse,
  AIToolCallResult,
  AIToolDefinition,
  EntityId,
  SiteCoreChannelType,
  SiteInsightsSession,
} from "./data-contracts";

/**
 * @description Generate an AI response in a conversation.
 * @tags site-ai
 * @name StreamAiResponseInSite
 * @summary Generate an AI response in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/ai/response
 * @secure
 */

// @ts-ignore
export const streamAIResponseInSite: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: true;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The ID of the previous response to continue from */
    previousResponseId?: string;
    /** The messages to send to the AI agent. */
    input: AIMessageInput[];
    model?: AIModel;
    /** Custom tools to provide to the AI agent. */
    tools?: AIToolDefinition[];
    /** Result of a tool call. */
    toolCall?: AIToolCallResult;
    /** Identifiers for a GitBook site session, used for analytics and adaptive content. */
    session?: SiteInsightsSession;
    /** The channel from which the question was asked, if applicable. */
    channel?: {
      type: SiteCoreChannelType;
    };
  };
  RequestHeaders: {
    /**
     * User agent of the visitor, when calling on behalf of one, such as from a server rendering a
     * docs site. When omitted, the request's own `User-Agent` is used.
     */
    "X-Original-User-Agent"?: string;
    /**
     * `Signature-Agent` header sent by the visitor, when calling on behalf of one, for agents that
     * sign their requests. When omitted, the request's own `Signature-Agent` is used.
     * https://datatracker.ietf.org/doc/draft-meunier-web-bot-auth-architecture/
     */
    "X-Original-Signature-Agent"?: string;
  };
  ResponseBody: AIStreamResponse;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/ai/response",
  method: "post",
  streaming: true,
  tags: ["site-ai"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
